import AutomatedHero from "./AutomatedHero";
import AutomatedEmployee from "./AutomatedEmployee";
import AutomatedBenefits from "./AutomatedBenefits";
import AutomatedRecommend from "./AutomatedRecommend";
const Automated = () => {
    return (
        <>
            <AutomatedHero />
            <AutomatedEmployee />
            <AutomatedBenefits />
            <AutomatedRecommend />
        </>
    );
};

export default Automated;